.addToBagButton {
  padding-left: 8px;
  padding-right: 8px;
  text-wrap: nowrap;
}

.count {
  background-color: var(--colors-text-inverse);
  color: var(--colors-primary-main);
  display: inline-block;
  border-radius: 12px;
}

.textContrastColor {
  color: var(--colors-text-inverse);
}
